import { useRouter } from 'next/router';
import { logout } from '../data/customer-data';

export const useLogout = () => {
  const router = useRouter();

  const redirect = (path: string) => {
    router.push(path);
  };

  const logoutAndRedirectOnBehalf = async (path: string) => {
    await logout();
    redirect(path);
  };

  const logoutAndRefresh = async () => {
    await logout();
    router.reload();
  };

  return {
    path: '/',
    redirect,
    logoutAndRedirectOnBehalf,
    logoutAndRefresh,
  } as const;
};
